import React from 'react'
import {MdExpandMore} from 'react-icons/md';
import {
    Media,
    Button
} from "reactstrap";
import {Redirect} from "react-router-dom";
import dateHelpers from "../../helpers/DateHelper";

const propTypes = {};

class ClassTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            yclass: props.yclass,
        };
    }

    goToClass(e) {
        e.preventDefault();

        this.props.goToClass(this.state.yclass.id)
    }

    findTicketForClass() {
        return this.state.yclass.tickets && this.state.yclass.tickets[0] ? this.state.yclass.tickets[0].name + ` (${this.state.yclass.tickets[0].id})` : "-"
    }

    render() {
        return (
            <tr>
                <th scope="row">
                    <Media className="align-items-center">
                        <Media>
                            <span className="mb-0 text-sm">
                                {this.state.yclass && this.state.yclass.name ? this.state.yclass.name : "..."}
                            </span>
                        </Media>
                    </Media>
                </th>
                <td>
                    <span className="mb-0 text-sm">
                        {this.state.yclass && this.state.yclass.date ? dateHelpers.formatDate(new Date(this.state.yclass.date)) : ""}
                    </span>
                </td>
                {(this.props.showTicketInfo === undefined || this.props.showTicketInfo === false) && !this.props.showStudentsCount &&
                <td>
                    <span className="mb-0 text-sm">
                        {this.findTicketForClass()}
                    </span>
                </td>
                }

                {(this.props.showStudentsCount && this.props.showStudentsCount === true) &&
                <td>
                    <span className="mb-0 text-sm">
                        {this.state.yclass.students || "0"} ({this.state.yclass.confirmed || "0"})
                    </span>
                </td>
                }
                <td className="text-right align-content-end">
                    <Button color="secondary"
                            onClick={e => this.goToClass(e)}>
                        <MdExpandMore/>
                    </Button>
                </td>
            </tr>
        )
    }
}

ClassTableRow.propTypes = propTypes;

export default ClassTableRow;